import { User } from "@core/account/types";
import { atom } from "@mongez/react-atom";

export const userAtom = atom<User>({
  key: "user",
  beforeUpdate(newValue, oldValue) {
    // Only preserve accessToken if the new user has no accessToken but the old one does
    // AND the new user is not explicitly a guest (to prevent guest users from getting real user tokens)
    if (!newValue.accessToken && oldValue.accessToken && newValue.userType !== "guest") {
      newValue.accessToken = oldValue.accessToken;
    }

    return newValue;
  },
  default: {},
});
